<template>
  <div :style="containerStyle">
    <validation-provider name="password"
                         :rules="rules"
                         v-slot="{ errors }"
                         :style="passwordContainerStyle">
      <LabelPrimary>
        {{ passwordLabel }}
      </LabelPrimary>
      <InputTextPrimary inputType="password"
                        :placeholder="passwordPlaceholder"
                        v-bind="$attrs"
                        v-on="$listeners"
                        v-model="password"
                        @input="input => $emit('input', input)" />
      <FormErrorPrimary>
        {{ errors[0] }}
      </FormErrorPrimary>
    </validation-provider>
    <template v-if="!disablePasswordConfirmation">
      <validation-provider name="password confirmation"
                           rules="required|confirmed:password"
                           v-slot="{ errors }"
                           :style="anotherPasswordContainerStyle">
        <LabelPrimary>
          {{ anotherPasswordLabel }}
        </LabelPrimary>
        <InputTextPrimary inputType="password"
                          v-bind="$attrs"
                          :placeholder="anotherPasswordPlaceholder"
                          v-model="anotherPassword" />
        <FormErrorPrimary>
          {{ errors[0] }}
        </FormErrorPrimary>
      </validation-provider>
    </template>
  </div>
</template>

<script>
  import FormErrorPrimary from '@modules/input/form-error-primary'
  import InputTextPrimary from '@modules/input/input-text-primary'
  import LabelPrimary from '@modules/input/label-primary'
  import { ValidationProvider } from 'vee-validate'
  import { Layout } from '@js/styles'
  import { confirmed, min, required, strong_password } from '@js/validators/rules'

  export default {
    name: 'FormPasswordPrimary',
    inheritAttrs: false,
    model: {
      prop: 'vmodelValue',
      event: 'input',
    },
    components: {
      FormErrorPrimary,
      InputTextPrimary,
      LabelPrimary,
      ValidationProvider,
    },
    props: {
      vmodelValue: { type: String },
      anotherPasswordLabel: { type: String, required: false, default: 'Confirm password' },
      anotherPasswordPlaceholder: { type: String, required: false, default: 'Re-enter your password' },
      disablePasswordConfirmation: { type: Boolean, required: false, default: false },
      disableStrongPassword: { type: Boolean, required: false, default: false },
      passwordLabel: { type: String, required: false, default: 'Password' },
      passwordPlaceholder: { type: String, required: false, default: 'Enter your password' },
    },
    data: function () {
      return {
        anotherPassword: '',
        anotherPasswordContainerStyle: {
          margin: `${Layout.space.lg} 0 0 0`,
          width: '100%',
        },
        containerStyle: {
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          width: '100%',
        },
        password: this.vmodelValue,
        passwordContainerStyle: {
          width: '100%',
        },
      };
    },
    computed: {
      rules: function () {
        return this.disableStrongPassword ? 'required' : 'required|min:8|strong_password';
      },
    },
    watch: {
      vmodelValue: function (newVal, oldVal) {
        this.password = newVal;
      },
    },
  };
</script>
